<!-- <div class="flex justify-content-center w-screen h-screen bg-login-container">
  <div class="flex justify-content-center align-items-center w-full sm:w-30rem h-full">
    <div class="flex w-11" *ngIf="step == stepOptions.login">
      <app-login class="w-full p-2" [srcLogo]="srcLogo" [form]="form" (response)="checkCredential()"></app-login>
    </div>
    <div class="flex flex-column w-screen" *ngIf="step != stepOptions.login">
      <div class="flex w-screen justify-content-center sm:pt-8 overflow-y-auto overflow-x-hidden" style="height: calc(100vh - 5rem)">
        <div class="flex w-screen justify-content-center" *ngIf="step == stepOptions.validate">
          <app-validate-user class="w-full" [mati]="mati" [userId]="user.id" (response)="onResponseValidateUser($event)"></app-validate-user>
        </div>
        <div class="flex" *ngIf="step == stepOptions.check">
          <app-check-user [user]="user" (response)="onResponseCheckUser()"></app-check-user>
        </div>
        <div class="flex flex-column justify-content-center" *ngIf="step == stepOptions.retry">
          <p class="text-center text-2xl">La validacion de usuario no fue concluida.</p>
          <p class="text-center text-xl">Por favor, vuelva a intentarlo</p>
          <div class="flex justify-content-center mt-6">
            <p-button type="button" label="Iniciar" icon="pi" size="large" icon="pi pi-send" (click)="step=stepOptions.validate"></p-button>
          </div>
        </div>
        <div class="flex flex-column justify-content-center" *ngIf="step == stepOptions.closed">
          <p class="text-center text-2xl">La validacion de usuario no fue satisfactoria.</p>
          <p class="text-center text-xl">Por favor, asegurese de ubicarse en un recinto cerrado y que haya suficiente luz. Que el documento de identificación se vea correctamente.</p>
          <div class="flex justify-content-center mt-6">
            <p-button type="button" label="Reintentar" icon="pi" size="large" icon="pi pi-replay" class="w-full" (click)="step=stepOptions.validate"></p-button>
          </div>
        </div>
        <div class="flex flex-column" *ngIf="step == stepOptions.waiting"></div>
      </div>
      <div class="flex h-5rem align-items-end w-screen justify-content-center">
        <img [src]="srcLogo" class="flex h-3rem">
      </div>
    </div>
  </div>
</div> -->

<div class="login admin-layout" style="background-image:url('assets/images/backgrounds/background-admin.jpg');">
  <div class="login__container">
    <ng-container *ngIf="step == stepOptions.login">
      <div class="login__form">
        <app-login [srcLogo]="srcLogo" [form]="form" (response)="checkCredential()"></app-login>
      </div>
    </ng-container>

    
    <div class="flex flex-column w-screen" *ngIf="step != stepOptions.login">
      <div class="flex w-screen justify-content-center sm:pt-8 overflow-y-auto overflow-x-hidden" style="height: calc(100vh - 5rem)">
        <div class="flex w-screen justify-content-center" *ngIf="step == stepOptions.validate">
          <app-validate-user class="w-full" [mati]="mati" [userId]="user.id" (response)="onResponseValidateUser($event)"></app-validate-user>
        </div>
        <div class="flex" *ngIf="step == stepOptions.check">
          <app-check-user [user]="user" (response)="onResponseCheckUser()"></app-check-user>
        </div>
        <div class="flex flex-column justify-content-center" *ngIf="step == stepOptions.retry">
          <p class="text-center text-2xl">La validacion de usuario no fue concluida.</p>
          <p class="text-center text-xl">Por favor, vuelva a intentarlo</p>
          <div class="flex justify-content-center mt-6">
            <p-button type="button" label="Iniciar" icon="pi" size="large" icon="pi pi-send" (click)="step=stepOptions.validate"></p-button>
          </div>
        </div>
        <div class="flex flex-column justify-content-center" *ngIf="step == stepOptions.closed">
          <p class="text-center text-2xl">La validacion de usuario no fue satisfactoria.</p>
          <p class="text-center text-xl">Por favor, asegurese de ubicarse en un recinto cerrado y que haya suficiente luz. Que el documento de identificación se vea correctamente.</p>
          <div class="flex justify-content-center mt-6">
            <p-button type="button" label="Reintentar" icon="pi" size="large" icon="pi pi-replay" class="w-full" (click)="step=stepOptions.validate"></p-button>
          </div>
        </div>
        <div class="flex flex-column" *ngIf="step == stepOptions.waiting"></div>
      </div>
      <div class="flex h-5rem align-items-end w-screen justify-content-center">
        <img [src]="srcLogo" class="flex h-3rem">
      </div>
    </div>
  </div>
</div>
